import { ballastItemLabel } from "../../../../utils/ballastItemLabel";
import { Button, message, Modal, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import AppInput from "../../../../components/AppInput";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SelectInput from "../../../../components/SelectInput";
import useUserData from "../../../../hooks/useUserData";
import useDocumentUpload from "../../../../hooks/useDocumentUpload";
import SecurityCodeModal from "../../../../components/SecurityCodeModal";

function EditBallastRecordBookModel({
  visible,
  onClose,
  child_id,
  ballast_id,
}) {
  const navigate = useNavigate();
  const user = useUserData();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [code, set_code] = useState("");
  const [date, set_date] = useState(null);
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [initialDocument, setInitialDocument] = useState([]);
  const [initialFormState, setInitialFormState] = useState({});
  const [soft_delete, set_soft_delete] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload(initialDocument);
  let codes = "H";

  const viewOnly = localStorage.getItem("viewOnly");

  const LIST_BALLAST_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ballasting_codes_staff, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.operation_codes?.map((item) => ({
            value: item?.value,
            label: item?.label,
          }));
          setCodeList(res?.operation_codes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_BALLAST_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code", code_id);
      post(ApiURL.list_ballasting_items_staff, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.operation_items?.map((item) => ({
            value: item?.id,
            label: ballastItemLabel(item?.item_number),
            sub_code_name: item?.description,
          }));
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      return exists
        ? prevItems.filter((item) => item.id !== value)
        : [...prevItems, { id: value, value: "" }];
    });
  };

  const handleInputChange = (id, inputValue) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, value: inputValue } : item
      )
    );
  };

  const VIEW_BALLAST_RECORD_BOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", child_id);
    FORM_DATA.append("parent_id", atob(ballast_id));
    FORM_DATA.append("request_type", "view");
    post(ApiURL.view_or_update_ballasting_details_staff, FORM_DATA).then(
      (res) => {
        if (res?.status == true) {
          const oilRecordData = res?.data;
          const subDetailValues = Array.isArray(
            oilRecordData?.sub_detail_values
          )
            ? oilRecordData?.sub_detail_values
            : typeof oilRecordData?.sub_detail_values === "string"
            ? JSON.parse(oilRecordData?.sub_detail_values || "[]")
            : [];

          setSelectedItems(subDetailValues);
          set_code(oilRecordData?.operationCode);
          set_date(oilRecordData?.date);
          set_signature(oilRecordData?.cargo_sign);
          setSubmitStatus(res?.submit_status);
          setInitialDocument(oilRecordData?.files);
          set_soft_delete(oilRecordData?.soft_delete);
          setInitialFormState({
            code: oilRecordData?.operationCode,
            date: oilRecordData?.date,
            signature: oilRecordData?.ballasting_sign,
            selectedItems: subDetailValues,
          });
          set_Previous_Log_Date(res?.last_date);
        } else {
          set_errors(res?.errors || {});
        }
      }
    );
  };

  const UPDATE_BALLAST_RECORD_BOOK_APIS = async (save_submit) => {
    const files = getFilesForUpload();
    set_loader(true);
    if (selectedItems.some((item) => !item.value)) {
      alert("All checked input should be filled");
      set_loader(false);
      return;
    }
    const FORM_DATA = new FormData();
    FORM_DATA.append("request_type", "edit");
    FORM_DATA.append("save_submit", Number(save_submit) || 0);
    FORM_DATA.append("record_id", atob(ballast_id));
    FORM_DATA.append("code_category_id", code);
    FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
    FORM_DATA.append("date", date);
    FORM_DATA.append("ballasting_sign", signature);
    files?.forEach((file) => {
      FORM_DATA.append("files", file);
    });
    post(ApiURL.view_or_update_ballasting_details_staff, FORM_DATA).then(
      (res) => {
        set_loader(false);
        if (res?.status == true) {
          SuccessToast(
            "Congratulation!!",
            "Update Oil Record Details Successfully Updated!!"
          );
          navigate("/list-ballast-record");
        } else {
          ErrorToast("Error message", res?.message);
          set_errors(res?.errors || {});
        }
      }
    );
  };

  useEffect(() => {
    LIST_BALLAST_RECORD_CODE_API();
    if (child_id) VIEW_BALLAST_RECORD_BOOK_APIS();
  }, [child_id, visible]);

  useEffect(() => {
    if (code) {
      LIST_BALLAST_RECORD_ITEM_API(code);
    }
  }, [code]);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const reomveItem = async (file) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("file_name", file.name);

    try {
      const res = await post(ApiURL.remove_ballast_file_st, FORM_DATA);
      if (res?.status === true) {
        SuccessToast("Success", "File removed successfully");
        VIEW_BALLAST_RECORD_BOOK_APIS();
      } else {
        ErrorToast("Error", "Failed to remove file");
      }
    } catch (error) {
      console.error("Error removing file:", error);
      ErrorToast("Error", "Failed to remove file");
    }
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,

          ((!soft_delete &&
            user?.data?.designation !== "Captain" &&
            child_id) ||
            viewOnly == 1) &&
            viewOnly != 0 && (
              <Button
                key="captain-save"
                type="primary"
                loading={loader}
                onClick={UPDATE_BALLAST_RECORD_BOOK_APIS}
              >
                Save
              </Button>
            ),
        ]}
        width={1000}
      >
        <div className="white-container">
          <br />
          <h3>Ballast Record Information</h3>
          <br />

          <div className="row">
            <div className="col-6">
              <SelectInput
                disabled={submitStatus}
                label="Code"
                value={code}
                placeholder="-- Select Code --"
                style={{ width: "100%" }}
                onChange={(value) => {
                  set_code(value);
                  setSelectedItems([]);
                  LIST_BALLAST_RECORD_ITEM_API(value);
                }}
                options={codeList}
                errors={errors?.code}
              />
            </div>
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                type="date"
                label="Date"
                placeholder="Date"
                value={date}
                onChange={(e) => set_date(e.target.value)}
                errors={errors.date}
                // min={previous_log_date}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          {code && (
            <div
              className="col-12"
              style={{
                lineHeight: "2",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
              }}
            >
              <strong className="form-label">Select Items:</strong>
              {codeItemList?.map((option, index) => {
                return (
                  <div key={index} className="mb-3">
                    <div className="row align-items-center mb-2">
                      <div className="col-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={option.label}
                            checked={selectedItems.some(
                              (item) => item.id === option.value
                            )}
                            // checked={true}
                            onChange={() => handleCheckboxChange(option.value)}
                            id={`group-checkbox-${index}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`group-checkbox-${index}`}
                          >
                            <strong>
                              {option.label} {option.sub_code_name}
                            </strong>
                          </label>
                        </div>
                      </div>
                      <div className="col-6">
                        {selectedItems.some(
                          (item) => item.id === option.value
                        ) && (
                          <Input
                            type="text"
                            required
                            className="form-control"
                            placeholder={option.label}
                            value={
                              selectedItems.find(
                                (item) => item.id === option.value
                              )?.value || ""
                            }
                            onChange={(e) =>
                              handleInputChange(option.value, e.target.value)
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {errors?.sub_detail_values && (
            <span style={{ color: "red" }}>{errors?.sub_detail_values}</span>
          )}

          <div className="row" style={{ paddingTop: "10px" }}>
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                label="Name of operation incharge"
                placeholder="Name of operation incharge"
                value={signature}
                onChange={(e) => set_signature(e.target.value)}
                errors={errors.signature}
              />
            </div>
            <div className="col-6">
              <div
                className="input-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <label>Select File</label>
                <Upload
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  multiple
                  fileList={documentList}
                  onChange={handleDocumentChange}
                  onPreview={handlePreviews}
                  beforeUpload={() => false}
                  listType="picture"
                  onRemove={reomveItem}
                >
                  <Button
                    icon={<UploadOutlined />}
                    type="primary"
                    style={{
                      borderRadius: "50%",
                      padding: "10px",
                      width: "40px",
                      height: "40px",
                      marginLeft: "10px",
                    }}
                  />
                </Upload>
              </div>
            </div>
          </div>

          <SecurityCodeModal
            record_id={ballast_id}
            visible={modalVisible}
            setModalVisible={setModalVisible}
            onCancel={() => setModalVisible(false)}
            onSuccess={() => {
              UPDATE_BALLAST_RECORD_BOOK_APIS("1");
              setModalVisible(false);
            }}
            apiEndPoint={ApiURL.verify_security_code_st}
          />
        </div>
      </Modal>
    </>
  );
}

export default EditBallastRecordBookModel;
